import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ILocationState }       from 'Redux/Slices/Location/LocationSlice';
import { Location }             from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const findLocationRequest = (state: Draft<ILocationState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findLocationSuccess = (state: Draft<ILocationState>, { type, payload }: PayloadAction<{
  location: Location
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, [payload.location.id]: payload.location };
};

export const findLocationFailure = (state: Draft<ILocationState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
